import { theme } from 'src/theme'

const box = {
  background: theme.palette.primary.main,
  opacity: 0.9,
  position: 'fixed',
  bottom: 0,
  left: 0,
  padding: '2px 10px',
  width: '100%',
  zIndex: 3,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  minHeight: '20px'
} as const

const footerLink = {
  color: '#fff',
  marginBottom: '0px',
  fontSize: '18px',
  textDecoration: 'none',
  paddingTop: '0px',
  paddingRight: '10px',
  '&:hover': {
    color: 'red',
    transition: '200ms ease-in'
  }
} as const

export const styles = { box, footerLink }
